import React, { useRef } from 'react';
import { CAREERS_ASSETS } from './careersAssets';
import { StartLink } from './StartLink';

export const CareersHero = () => {
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current;
    if (!el || e.pointerType === 'touch' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const r = el.getBoundingClientRect();
    el.style.setProperty('--mx', `${((e.clientX - r.left) / r.width - 0.5) * 22}px`);
    el.style.setProperty('--my', `${((e.clientY - r.top) / r.height - 0.5) * 16}px`);
  };
  const onLeave = () => {
    ref.current?.style.setProperty('--mx', '0px');
    ref.current?.style.setProperty('--my', '0px');
  };

  return (
    <section className="become" ref={ref} onPointerMove={onMove} onPointerLeave={onLeave} data-testid="careers-hero">
      <div className="campaign-atmosphere" aria-hidden="true">
        <div className="light-cloud" />
        <div className="studio-beam beam-one" />
        <div className="studio-beam beam-two" />
        <div className="contour contour-one" />
        <div className="contour contour-two" />
        <div className="film-grain" />
      </div>
      <div className="kicker">
        <span>GLEAM GURU CLEANERS / CAREERS</span>
        <span>PORTLAND, OR · VANCOUVER, WA</span>
      </div>
      <div className="become-grid">
        <div className="become-copy">
          <p className="eyebrow">HOUSE &amp; COMMERCIAL CLEANERS</p>
          <h1>BECOME <br />A <span>GURU.</span></h1>
          <p className="become-intro">House &amp; commercial cleaning opportunities. <br />No experience required for the W-2 path—bring your willingness to learn.</p>
          <StartLink className="desktop-header-apply" testId="hero-apply-desktop" />
        </div>
        <div className="crew-light" aria-hidden="true" />
        <div className="crew-frame" aria-hidden="true"><span>GLEAM GURU CLEANERS</span><i /></div>
        <div className="luxury-scene">
          <img src={CAREERS_ASSETS.sprayWoman} alt="Woman in the orange Guru shirt aiming a spray bottle toward the camera" />
        </div>
        <StartLink className="mobile-header-apply" testId="hero-apply-mobile" />
      </div>
    </section>
  );
};
